import { useCallback, useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Unity, useUnityContext } from "react-unity-webgl";
import axios from "axios";

// import { io } from "socket.io-client";
import mqtt from 'mqtt';

import useRefreshToken from "../../hooks/useRefreshToken"
import { clearToken } from "../../auth/tokenStore";
import { logout } from "../../slice/authSlice";

import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";

import { Icon } from "../icons";
import CloseIcon from "@mui/icons-material/Close";
import CarouselTotal from "../Sfv_Carousel";
import SideBar from "../SideBar";
import CustomProgressBar from "../ProgressBar";
import ProgressInfo from "../ProgressBar/progressInfo";
import RadarChart from "../Graph/radar";
import KPICards from "../KPICards";
import InfoTable from "../InfoTable";
import RiskTableDialog from "./RiskDialog";
import BrokenLogDialog from "./BrokenLogDialog";
import CCTVDialog from "./CCTVDialog";
import BrokenImageDialog from "./BrokenImageDialog";

import API_URL from "../../utils/API_URL";

import { useDispatch, useSelector } from "react-redux";
import { setChattingStatus } from "../../slice/authSlice";
// import GanttGraph from "../GanttGraph";
// import MergeSummary from "../Summary/Merge";
// import SummaryResult from "../Summary/Result";
// import SummaryLine from "../Summary/SummaryLine";
// import PlanWeek from "../Summary/Week";
// import GanttSimulation1 from "../GanttSimulation/Sim1";
// import GanttSimulation2 from "../GanttSimulation/Sim2";
// import WorkerTable from "../WorkerTable";

// 로딩 화면 스타일 시트
import '../../styles/loader.css';

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

const DrawerTitle = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

const DrawerContent = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledTable = styled("table")(({ theme }) => ({
  width: "100%",
  borderCollapse: "collapse",
  "tbody tr td": {
    padding: "0.2rem 0.4rem",
  },
  "tbody tr td:first-of-type": {
    color: "#ffffff",
    width: "50%",
  },
  "tbody tr td:last-of-type": {
    color: "#878a99",
  },
}));

function SfvPage() {
  const { group_code, project_code } = useParams();
  const { unityProvider, unload, sendMessage } = useUnityContext({
    loaderUrl: "https://dev.insightwin.com/Build/WebGL.loader.js",
    dataUrl: "https://dev.insightwin.com/Build/WebGL.data.gz",
    frameworkUrl: "https://dev.insightwin.com/Build/WebGL.framework.js.gz",
    codeUrl: "https://dev.insightwin.com/Build/WebGL.wasm.gz",
    streamingAssetsUrl: `https://dev.insightwin.com/StreamingAssets/${group_code}/${project_code}`,
  });
  const dispatch = useDispatch();
  const unityContainerRef = useRef(null);
  const [devicePixelRatio, setDevicePixelRatio] = useState(
    window.devicePixelRatio
  );
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerContent, setDrawerContent] = useState(null);
  const [currentMchId, setCurrentMchId] = useState("");
  const [radarData, setRadarData] = useState([0, 0, 0, 0, 0, 0]);
  const [selectedIndicator, setSelectedIndicator] = useState(null);
  const [indicatorData, setIndicatorData] = useState({});
  const [BrokenImageShow, setBrokenImageShow] = useState(false);
  const [CCTVShow, setCCTVShow] = useState(false);
  const [riskTableShow, setRiskTableShow] = useState(false);
  const [riskTableData, setRiskTableData] = useState({});
  const [brokenLogShow, setbrokenLogShow] = useState(false);
  const [brokenLogData, setbrokenLogData] = useState({});
  const { chattingStatus } = useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async (mchId) => {
    try {
      const response = await axios.post(API_URL + "/drawer/getAssetData", {
        mchId,
      });

      if (response.status === 404) {
        setDrawerContent(null);
        setRadarData([0, 0, 0, 0, 0, 0]);
        setIndicatorData({});
        return;
      }

      const { asset, radarData, indicatorData } = response.data;

      setDrawerContent(asset);
      setRadarData(radarData);
      setIndicatorData(indicatorData);
      console.log(asset);
    } catch (error) {
      console.error("Error fetching data:", error);
      setDrawerContent(null);
      setRadarData([0, 0, 0, 0, 0, 0]);
      setIndicatorData({});
    }
  };

  const fetchRiskTableData = async (mchId) => {
    try {
      const response = await axios.post(API_URL + "/drawer/getRiskDialogData", {
        mchId,
      });
      if (response.status === 404) {
        setRiskTableData({});
        return;
      }
      const { riskData } = response.data;

      setRiskTableData(riskData);
    } catch (error) {
      console.error("Error fetching data:", error);
      setRiskTableData({});
    }
  };

  const fetchBrokenLogData = async (mchId) => {
    try {
      const response = await axios.post(API_URL + "/drawer/getBrokenLogData", {
        mchId,
      });
      if (response.status === 404) {
        setbrokenLogData({});
        return;
      }
      const { brokenLogData } = response.data;

      setbrokenLogData(brokenLogData);
    } catch (error) {
      console.error("Error fetching data:", error);
      setbrokenLogData({});
    }
  };

  const SFV_FinishLoading = useCallback((msg) => {
    console.log(msg);
    if (msg === "Initialization start") {
      setIsLoading(false);
    }
  }, []);

  const SFV_UpdateData = useCallback((mchId, pickingData) => {
    console.log("MchID:", mchId, "PickingData:", pickingData);
    if (mchId !== "" && pickingData.includes('"type":21')) {
      setCurrentMchId(mchId);
      fetchData(mchId);
      setDrawerOpen(true);
    }
    if (mchId === "1" && pickingData.includes('"type":0')) {
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then(() => {
          console.log("마이크 권한 승인");
          sendMessage("Canvas", "CurrentMicrophoneStatus", "Enable");
        })
        .catch((error) => {
          console.error("마이크 권한 획득 실패: ", error);
          sendMessage("Canvas", "CurrentMicrophoneStatus", error.message);
        });
    }
  }, [sendMessage]);

  const SFV_UpdateStatus = useCallback((type, status) => {
    dispatch(
      setChattingStatus({
        type,
        status,
      })
    );
    // setStatus(`${type}: ${status}`);
  }, []);

  const updateCanvasSize = () => {
    const unityContainer = unityContainerRef.current;
    if (unityContainer) {
      const canvas = unityContainer.querySelector("canvas");
      if (canvas) {
        const newWidth = unityContainer.clientWidth;
        const newHeight = unityContainer.clientHeight;
        const resolutionWidth = newWidth * window.devicePixelRatio;
        const resolutionHeight = newHeight * window.devicePixelRatio;

        // 캔버스 크기 조정
        // canvas.style.width = `${newWidth}px`;
        // canvas.style.height = `${newHeight}px`;

        // 유니티 WebGL 내부 해상도 업데이트
        canvas.width = resolutionWidth;
        canvas.height = resolutionHeight;
      }
    }
  };

  // Refresh Token 갱신
  const refresh = useRefreshToken();

  useEffect(() => {
    let refreshInterval;
  
    const setupRefreshInterval = () => {
      if (refreshInterval) {
        console.log("Clearing existing interval");
        clearInterval(refreshInterval);
      }
  
      refreshInterval = setInterval(async () => {
        try {
          console.log("토큰 갱신중");
          await refresh(); // Refresh Token 갱신
          console.log("토큰 갱신 완료");
        } catch (error) {
          console.error("Failed to refresh tokens:", error);
          clearToken();
          dispatch(logout());
        }
      }, 12 * 60 * 60 * 1000);
    };
  
    setupRefreshInterval();
  
    return () => {
      console.log("Clearing interval on cleanup");
      clearInterval(refreshInterval); // 컴포넌트 언마운트 시 정리
    };
  }, [refresh, dispatch]);

  // !! 웹 소켓 데이터 수신 테이스
  // useEffect(() => {
  //   // Socket.io 연결 설정
  //   const socket = io("https://dev.insightwin.com", { path: "/ws/" });

  //   socket.on("connect", () => {
  //     console.log("WebSocket 연결이 열렸습니다.");
  //   });

  //   socket.on("machinesUpdate", (data) => {
  //     console.log("machinestatus 업데이트 수신:", data);
  //   });

  //   socket.on("statusUpdate", (data) => {
  //     console.log("status 업데이트 수신:", data);
  //   });

  //   socket.on("disconnect", () => {
  //     console.log("WebSocket 연결이 닫혔습니다.");
  //   });

  //   socket.on("connect_error", (error) => {
  //     console.error("WebSocket 에러:", error);
  //   });

  //   // 컴포넌트 언마운트 시 WebSocket 연결 종료
  //   return () => {
  //     socket.disconnect();
  //   };
  // }, []);

  // MQTT 연결 설정
  useEffect(() => {
    const client = mqtt.connect('wss://dev.insightwin.com:9883', {
      username: 'testuser',
      password: '1111',
    });

    client.on('connect', () => {
      console.log('MQTT에 연결되었습니다.');
      
      client.subscribe('updates/machinestatus', (err) => {
        if (err) {
          console.error('MQTT 구독 실패:', err);
        } else {
          console.log('machinestatus 구독 중...');
        }
      });

      client.subscribe('updates/statusmaster', (err) => {
        if (err) {
          console.error('MQTT 구독 실패:', err);
        } else {
          console.log('statusmaster 구독 중...');
        }
      });
    });

    client.on('message', (topic, message) => {
      console.log(`수신된 메시지 [${topic}]:`, message.toString());
    });

    client.on('error', (error) => {
      console.error('MQTT 에러:', error);
    });

    // 컴포넌트 언마운트 시 연결 해제
    return () => {
      client.end();
    };
  }, []);


  useEffect(() => {
    const unityContainer = unityContainerRef.current;

    const handleDevicePixelRatioChange = () => {
      // console.log("Device Pixel Ratio:", window.devicePixelRatio);
      setDevicePixelRatio(window.devicePixelRatio);
      updateCanvasSize();
    };

    const mediaMatcher = window.matchMedia(
      `screen and (resolution: ${window.devicePixelRatio}dppx)`
    );
    mediaMatcher.addEventListener("change", handleDevicePixelRatioChange);

    updateCanvasSize();

    const observer = new ResizeObserver(() => {
      updateCanvasSize();
    });

    if (unityContainer) {
      observer.observe(unityContainer);
    }

    return () => {
      mediaMatcher.removeEventListener("change", handleDevicePixelRatioChange);
      if (unityContainer) {
        observer.unobserve(unityContainer);
      }
    };
  }, [devicePixelRatio]);

  useEffect(() => {
    window.SFV_UpdateData = SFV_UpdateData;
    window.SFV_UpdateStatus = SFV_UpdateStatus;
    window.SFV_FinishLoading = SFV_FinishLoading;
    return () => {
      delete window.SFV_UpdateData;
      delete window.SFV_UpdateStatus;
      delete window.SFV_FinishLoading;
    };
  }, [SFV_UpdateData, SFV_UpdateStatus, SFV_FinishLoading]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      const clickedInsideDrawer = event.target.closest(".MuiDrawer-paper");
      const clickedInsideDialog = event.target.closest(".MuiDialog-paper");
      if (drawerOpen && !clickedInsideDrawer && !clickedInsideDialog) {
        setDrawerOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [drawerOpen]);
  useEffect(() => {
    if (!drawerOpen) {
      sendMessage("Canvas", "ClearMachineData", "Picking");
    }
  }, [drawerOpen, sendMessage]);
  useEffect(() => {
    const preventDefault = (event) => {
      event.preventDefault();
    };

    const bodyElement = document.body;

    bodyElement.addEventListener("contextmenu", preventDefault);
    bodyElement.addEventListener("dragstart", preventDefault);
    bodyElement.addEventListener("selectstart", preventDefault);

    return () => {
      bodyElement.removeEventListener("contextmenu", preventDefault);
      bodyElement.removeEventListener("dragstart", preventDefault);
      bodyElement.removeEventListener("selectstart", preventDefault);
    };
  }, []);
  const handleIndicatorClick = useCallback((indicatorName) => {
    setSelectedIndicator(indicatorName);
  }, []);

  const handleBrokenImageClose = () => {
    setBrokenImageShow(false);
  };

  const handleCCTVOpen = () => {
    setCCTVShow(true);
  };

  const handleCCTVClose = () => {
    setCCTVShow(false);
  };

  const handleRiskDialogOpen = (mchId) => {
    fetchRiskTableData(mchId);
    setRiskTableShow(true);
  };

  const handleRiskDialogClose = () => {
    setRiskTableShow(false);
  };

  const handleBrokenLogDialogOpen = (mchId) => {
    fetchBrokenLogData(mchId);
    setbrokenLogShow(true);
  };

  const handleBrokenLogDialogClose = () => {
    setbrokenLogShow(false);
  };

  const isMachineBroken = drawerContent?.machine_status === 9;

  return (
    <div id="sfv-page">
      <SideBar unload={unload} />
      <Box
        sx={{
          position: "absolute",
          top: "20px",
          left: "80px",
          right: 0,
          display: "flex",
          justifyContent: "center",
          zIndex: 10,
        }}
      >
        <KPICards />
      </Box>
      <div
        ref={unityContainerRef}
        style={{
          width: "calc(100vw - 80px)",
          height: "100vh",
          overflow: "hidden",
          marginLeft: "80px",
        }}
      >
        <Unity
          unityProvider={unityProvider}
          style={{ width: "100%", height: "100%" }}
          // 중요한 옵션, 디폴트가 true인데 WebGL 해상도를 캔버스 사이즈에 강제로 일치시킴
          matchWebGLToCanvasSize={false}
        />
        
        {/* 로딩 화면 */}
        {isLoading && (
          <div 
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 9999
            }}
          >
            <img 
              src="/images/ese_logo.png" 
              alt="ESE Logo" 
              style={{ 
                width: '200px', 
                marginBottom: '30px' 
              }} 
            />
            <div className="loader"></div>
          </div>
        )}
        
        {/* 장비 상세 정보창 */}
        <Drawer
          anchor="right"
          open={drawerOpen}
          ModalProps={{
            keepMounted: true,
            hideBackdrop: true,
          }}
          sx={{
            "& .MuiDrawer-paper": {
              backgroundColor: "#121212",
              opacity: 0.85,
              color: "#ffffff",
              width: 350,
            },
          }}
        >
          <Box
            id="drawer-header"
            sx={{
              paddingY: "0.5rem",
              paddingX: "0.75rem",
              backgroundColor: "#000000",
            }}
            role="presentation"
          >
            <DrawerHeader>
              <Box sx={{ margin: 0, fontSize: "1.5em", fontWeight: 500 }}>
                {drawerContent ? drawerContent.asset_name : "장비 미연동"}
              </Box>
              <Box
                sx={{
                  margin: 0,
                  fontSize: "1.2em",
                  fontWeight: 400,
                  color: "#878a99",
                }}
              >{`연동ID: ${currentMchId}`}</Box>
              <IconButton
                onClick={() => setDrawerOpen(false)}
                sx={{ color: "#ced4da" }}
              >
                <CloseIcon />
              </IconButton>
            </DrawerHeader>
          </Box>
          <Divider />
          <Box
            id="progress-bar"
            sx={{ padding: 3, opacity: 1 }}
            role="presentation"
          >
            <CustomProgressBar
              startTime={drawerContent?.start_time}
              endTime={drawerContent?.end_time}
              machineStatus={drawerContent?.machine_status}
              plannedQty={drawerContent?.planned_qty}
              resultQty={drawerContent?.result_qty}
            />
            <ProgressInfo
              startTime={drawerContent?.start_time || "정보없음"}
              endTime={drawerContent?.end_time || "정보없음"}
            />
          </Box>
          <Divider />
          {isMachineBroken ? (
            <Box
              id="drawer-title"
              sx={{ padding: 3, backgroundColor: "#000000" }}
              role="presentation"
            >
              <DrawerTitle
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box sx={{ margin: 0, fontSize: "1.2em", fontWeight: 500 }}>
                  고장 정보
                </Box>
                <Chip
                  label="고장발생!"
                  size="small"
                  color="error"
                  variant="tonal"
                  icon={
                    <Icon
                      name="warningIcon"
                      style={{
                        width: "12px",
                        height: "12px",
                        color: "#FF0000",
                      }}
                    />
                  }
                />
              </DrawerTitle>
            </Box>
          ) : (
            <Box
              id="drawer-title"
              sx={{ padding: 3, backgroundColor: "#000000" }}
              role="presentation"
            >
              <DrawerTitle
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box sx={{ margin: 0, fontSize: "1.2em", fontWeight: 500 }}>
                  생산 정보
                </Box>
                <Button variant="contained" size="small">
                  작업지시서
                </Button>
              </DrawerTitle>
            </Box>
          )}
          <Divider />
          <Box
            id="drawer-content"
            sx={{ padding: "0.4rem" }}
            role="presentation"
          >
            <DrawerContent>
              <StyledTable>
                {isMachineBroken ? (
                  <tbody>
                    <tr>
                      <td>고장시간</td>
                      <td>{new Date().toLocaleDateString()} 10:00:00</td>
                    </tr>
                    <tr>
                      <td>예상완료시간</td>
                      <td>{new Date().toLocaleDateString()} 15:00:00</td>
                    </tr>
                    <tr>
                      <td>작업자</td>
                      <td>유재석</td>
                    </tr>
                    <tr>
                      <td>고장사진</td>
                      <td>
                        <button
                          onClick={() => setBrokenImageShow(true)}
                          style={{
                            background: "none",
                            border: "none",
                            color: "#007bff",
                            textDecoration: "underline",
                            cursor: "pointer",
                            padding: 0,
                          }}
                        >
                          사진확인
                        </button>
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td>작업지시번호</td>
                      <td>{drawerContent?.work_order || "장비 미연동"}</td>
                    </tr>
                    <tr>
                      <td>품명</td>
                      <td>{drawerContent?.item || "장비 미연동"}</td>
                    </tr>
                    <tr>
                      <td>수량</td>
                      <td>{drawerContent?.qty || "장비 미연동"}</td>
                    </tr>
                    <tr>
                      <td>공정명</td>
                      <td>{drawerContent?.process_name || "장비 미연동"}</td>
                    </tr>
                    <tr>
                      <td>작업자</td>
                      <td>{drawerContent?.worker || "장비 미연동"}</td>
                    </tr>
                  </tbody>
                )}
              </StyledTable>
            </DrawerContent>
          </Box>
          <Divider />
          <Box
            id="drawer-title"
            sx={{ padding: 1, backgroundColor: "#000000" }}
            role="presentation"
          >
            <RadarChart
              data={radarData}
              onIndicatorClick={handleIndicatorClick}
            />
          </Box>
          <Divider />
          <InfoTable
            indicatorData={indicatorData}
            selectedIndicator={selectedIndicator}
            onButtonClick={() => handleRiskDialogOpen(currentMchId)}
            onLogButtonClick={() => handleBrokenLogDialogOpen(currentMchId)}
            onCCTVButtonClick={() => handleCCTVOpen()}
          />
        </Drawer>
      </div>
      {/* <GanttGraph />
      <MergeSummary />
      <SummaryResult />
      <SummaryLine sendMessage={sendMessage} />
      <PlanWeek />
      <GanttSimulation1 />
      <GanttSimulation2 />
      <WorkerTable /> */}
      <CarouselTotal sendMessage={sendMessage} />
      <BrokenImageDialog
        open={BrokenImageShow}
        onClose={handleBrokenImageClose}
        imageUrl="/images/broken_241014.png"
        assetInfo={drawerContent?.asset_name || "장비 미연동"}
      />
      <CCTVDialog
        open={CCTVShow}
        onClose={handleCCTVClose}
        videoUrl="/CCTV/CCTV_SAMPLE.mp4"
        assetInfo={drawerContent?.asset_name || "장비 미연동"}
      />
      <RiskTableDialog
        open={riskTableShow}
        onClose={handleRiskDialogClose}
        data={riskTableData}
        assetInfo={drawerContent?.asset_name || "장비 미연동"}
      />
      <BrokenLogDialog
        open={brokenLogShow}
        onClose={handleBrokenLogDialogClose}
        data={brokenLogData}
        assetInfo={drawerContent?.asset_name || "장비 미연동"}
      />
    </div>
  );
}

export default SfvPage;
